import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authReducer";
import cartReducer from "./reducers/cartReducer";
import productReducer from "./reducers/ProductReducer";
import orderReducer from "./reducers/orderReducer";
import reviewReducer from "./reducers/reviewReducer";
import wishlistReducer from "./reducers/wishlistReducer";
import filterReducer from "./reducers/filterReducer";
import siteReducer from "./reducers/siteReducer";
import categoriesReducer from "./reducers/categoriesReducer";
import addressReducer from "./reducers/addressReducer";
// import filteredProductReducer from "./reducers/filteredProductReducer";
import slidesTextReducer from "./reducers/SlidesTextReducer";
import slidesReducer from "./reducers/SlidesReducer";
import shippingFeesReducer from "./reducers/shippingFeesReducer";
import brandsReducer from "./reducers/BrandReducer";
import advancedSearchReducer from "./reducers/advancedSearchReducer";
import couponReducer from "./reducers/couponReducer";
import referralReducer from "./reducers/referralReducer";
import popupReducer from "./reducers/popupReducer";
import routineReducer from "./reducers/routineReducer";

const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    products: productReducer,
    orders: orderReducer,
    review: reviewReducer,
    wishlist: wishlistReducer,
    filters: filterReducer,
    site: siteReducer,
    categories: categoriesReducer,
    address: addressReducer,
    // filteredProducts: filteredProductReducer,
    slidesText: slidesTextReducer,
    slides: slidesReducer,
    shippingFees: shippingFeesReducer,
    brands: brandsReducer,
    advancedSearch: advancedSearchReducer,
    coupons: couponReducer,
    referral: referralReducer,
    popups: popupReducer,
    routines: routineReducer,
  },
});

export default store;
